import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import TextInput from "../components/TextInput";
import Templates from "../tabs/Templates";
import Filters from "../tabs/Filters";
import { blackColor, violetColor, whiteColor } from "../constants/colors";
import Settings from "../tabs/Settings";
import Formats from "../tabs/Format";

const Main = () => {
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [loadingTemplates, setLoadingTemplates] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [gameCode, setGameCode] = useState(null);
  const [conceptNumber, setConceptNumber] = useState(null);
  const [variation, setVariation] = useState(null);
  const [languageCode, setLanguageCode] = useState(null);
  const [captionMain, setCaptionMain] = useState({
    startCutTimecode: 0,
    endCutTimecode: 59,
    visibility: true,
  });
  const [videoLength, setVideoLength] = useState(59);
  const [selectedCompositions, setSelectedCompositions] = useState([]);
  const [modifications, setModifications] = useState({
    sourceFootage800x1000: {
      layers: [
        {
          type: "video",
          value: "videoReplace_1_800x1000_59s.mp4",
          startCutTimecode: 0,
          endCutTimecode: 59,
        },
      ],
    },
    sourceFootage1080x1920: {
      layers: [
        {
          type: "video",
          value: "videoReplace_1_1080x1920_59s.mp4",
          startCutTimecode: 0,
          endCutTimecode: 59,
        },
      ],
    },

    sourceFootage1920x1080: {
      layers: [
        {
          type: "video",
          value: "videoReplace_1_1920x1080_59s.mp4",
          startCutTimecode: 0,
          endCutTimecode: 59,
        },
      ],
    },
  });

  const [selectedResolutions, setSelectedResolutions] = useState({
    "1080x1920": false,
    "1920x1080": false,
    "800x1000": false,
  });

  useEffect(() => {
    const calculateVideoLength = () => {
      const hasFirstVideo = modifications.sourceFootage800x1000.layers.find(
        (layer) => layer.value.includes("videoReplace_1")
      );
      const hasSecondVideo = modifications.sourceFootage800x1000.layers.find(
        (layer) => layer.value.includes("videoReplace_2")
      );

      if (
        hasFirstVideo &&
        hasSecondVideo &&
        currentTemplate.name.includes("merge")
      ) {
        const finalLength =
          hasFirstVideo.endCutTimecode -
          hasFirstVideo.startCutTimecode +
          hasSecondVideo.endCutTimecode -
          hasSecondVideo.startCutTimecode;
        if (finalLength > 59) {
          return alert("Video length should be less than 59 seconds");
        }
        return setVideoLength(finalLength);
      } else if (hasFirstVideo) {
        return setVideoLength(
          hasFirstVideo.endCutTimecode - hasFirstVideo.startCutTimecode
        );
      } else if (hasSecondVideo) {
        return setVideoLength(
          hasSecondVideo.endCutTimecode - hasSecondVideo.startCutTimecode
        );
      }
    };

    calculateVideoLength();
  }, [modifications]);

  const getTemplates = async () => {
    try {
      setLoadingTemplates(true);
      const response = await axios.get(
        "https://webrender-be.homagames.com/api/v1/getTemplates"
      );

      if (!response.data) {
        setLoadingTemplates(false);
        return;
      }

      console.log("getTemplates", response.data);
      const sortedTemplates = response.data.sort((a, b) => {
        if (
          a.name === "T02_music59s" &&
          b.name === "T02_mergeMusic30sPlus30s"
        ) {
          return -1;
        }
        if (
          a.name === "T02_mergeMusic30sPlus30s" &&
          b.name === "T02_music59s"
        ) {
          return 1;
        }
        return 0;
      });

      setTemplates(sortedTemplates);
      setCurrentTemplate(sortedTemplates[0]);
      setLoadingTemplates(false);
    } catch (error) {
      setLoadingTemplates(false);
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("selectedResolutions", selectedResolutions);
  }, [selectedResolutions]);

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    console.log("currentTemplate", currentTemplate);
  }, [currentTemplate]);

  useEffect(() => {
    console.log("modifications", modifications);
  }, [modifications]);

  const renderVideo = async () => {
    if (!variation || !conceptNumber || !gameCode || !languageCode) {
      alert("Please select a game code, concept number, local and variation.");
      return;
    }
    if (!selectedCompositions.length) {
      alert("Please select at least one composition to render.");
      return;
    }

    if (!currentTemplate) {
      alert("Please select a template to render.");
      return;
    }

    if (videoLength > 59) {
      alert("Video length should be less than 59 seconds");
      return;
    }

    let templateId = currentTemplate.id;
    let aepFilepath = currentTemplate.aepFilepath;
    const response = await axios.post(
      "https://webrender-be.homagames.com/api/v1/nexrender/createJob",
      {
        jobDescription: "Job Description",
        jobName: "Job Name",
        selectedCompositions,
        modifications,
        templateId,
        aepFilepath,
        gameCode,
        outputNameData: {
          gameCode,
          conceptNumber,
          variation,
          languageCode,
        },
        filter: selectedFilter,
        captionMain,
        videoLength,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);
    if (response.status === 201) {
      alert("Job created successfully");
    } else {
      alert("Error creating job");
    }
  };

  const handleModificationChange = useCallback(
    (newValue, composition, property, type, value) => {
      if (
        type === "video" &&
        (property === "startCutTimecode" || property === "endCutTimecode")
      ) {
        console.log(
          "fldslsldasdlafsd",
          newValue,
          composition,
          property,
          type,
          value
        );
        if (property === "endCutTimecode" && value.includes("videoReplace_1")) {
          const firstVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_1")
          );
          const secondVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_2")
          );
          if (firstVideo && secondVideo) {
            if (
              newValue -
                firstVideo.startCutTimecode +
                secondVideo.endCutTimecode -
                secondVideo.startCutTimecode >
              59
            ) {
              return;
            }
          }
        }
        if (
          property === "startCutTimecode" &&
          value.includes("videoReplace_1")
        ) {
          const firstVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_1")
          );
          const secondVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_2")
          );
          if (firstVideo && secondVideo) {
            if (
              firstVideo.endCutTimecode -
                newValue +
                secondVideo.endCutTimecode -
                secondVideo.startCutTimecode >
              59
            ) {
              return;
            }
          }
        }
        if (
          property === "startCutTimecode" &&
          value.includes("videoReplace_2")
        ) {
          const firstVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_1")
          );
          const secondVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_2")
          );
          if (firstVideo && secondVideo) {
            if (
              secondVideo.endCutTimecode -
                newValue +
                firstVideo.endCutTimecode -
                firstVideo.startCutTimecode >
              59
            ) {
              return;
            }
          }
        }
        if (property === "endCutTimecode" && value.includes("videoReplace_2")) {
          console.log("newValue", newValue);

          const firstVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_1")
          );
          const secondVideo = modifications?.[composition]?.layers?.find(
            (layer) => layer.value.includes("videoReplace_2")
          );
          if (firstVideo && secondVideo) {
            console.log("firstVideo", firstVideo, secondVideo);

            if (
              firstVideo.endCutTimecode -
                firstVideo.startCutTimecode +
                newValue -
                secondVideo.startCutTimecode >
              59
            ) {
              return;
            }
          }
        }
      }

      const prevLayer = modifications?.[composition]?.layers?.find(
        (layer) => layer.value === value && layer.type === type
      );

      const updatedLayer = {
        ...prevLayer,
        type,
        value,
        [property]: newValue,
      };

      setModifications((prev) => {
        console.log("prev", prev);

        const newModifications = { ...prev };

        if (!newModifications[composition]) {
          newModifications[composition] = { layers: [updatedLayer] };
        } else {
          const filteredLayers = newModifications[composition].layers.filter(
            (layer) => layer.value !== updatedLayer.value
          );
          newModifications[composition].layers = [
            ...filteredLayers,
            updatedLayer,
          ];
        }

        return newModifications;
      });
    },
    [modifications]
  );

  if (loadingTemplates) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "85vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={80}
          sx={{
            color: violetColor,
          }}
        />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          margin: "0 auto",
          width: "100%",
          maxWidth: "1325px",
          marginTop: "50px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
            marginLeft: "16px",
            paddingX: "30px",
          }}
        >
          <TextInput
            value={gameCode}
            onChange={(val) => setGameCode(val)}
            label={"Game code"}
            inputStyle={{ width: "60px" }}
          />
          <TextInput
            value={conceptNumber}
            onChange={(val) => setConceptNumber(val)}
            label={"Concept #"}
            inputStyle={{ width: "60px" }}
          />
          <TextInput
            value={variation}
            onChange={(val) => setVariation(val)}
            label={"Version #"}
            inputStyle={{ width: "60px" }}
          />
          <TextInput
            value={languageCode}
            onChange={(val) => setLanguageCode(val)}
            label={"Local"}
            inputStyle={{ width: "60px" }}
          />
        </Box>
        <Box sx={{ paddingX: "20px", marginTop: "30px" }}>
          <Templates
            templates={templates}
            currentTemplate={currentTemplate}
            setCurrentTemplate={setCurrentTemplate}
          />
        </Box>
        <Box sx={{ paddingX: "20px", marginTop: "30px" }}>
          <Formats
            formats={selectedResolutions}
            modifications={modifications}
            currentTemplate={currentTemplate}
            setModifications={setModifications}
            setSelectedCompositions={setSelectedCompositions}
            setSelectedResolutions={setSelectedResolutions}
            handleModificationChange={handleModificationChange}
          />
        </Box>
        <Box sx={{ paddingX: "20px", marginTop: "30px" }}>
          <Filters
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />
        </Box>
        <Box sx={{ paddingX: "20px", marginTop: "30px" }}>
          <Settings
            videoLength={videoLength}
            captionMain={captionMain}
            modifications={modifications}
            currentTemplate={currentTemplate}
            setVideoLength={setVideoLength}
            setCaptionMain={setCaptionMain}
            setModifications={setModifications}
            handleModificationChange={handleModificationChange}
          />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginY: "100px",
          }}
        >
          <Button
            onClick={renderVideo}
            sx={{
              borderColor: blackColor,
              backgroundColor: whiteColor,
              "&:hover": {
                backgroundColor: whiteColor,
              },
            }}
            variant="contained"
            color="secondary"
          >
            <Typography
              sx={{ color: violetColor, fontWeight: "500", fontSize: "36px" }}
            >
              Render
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Main;
